import { IApplicationState } from '@store'

export const selectFeedbackDraft = (state: IApplicationState, submissionId: number) =>
  state.feedbackDraft.feedbackDraftBySubmissionId[submissionId] ?? ''
